import {useQuery} from '@tanstack/react-query';
import WeddingWebsiteGraphQL from '../services/WeddingWebsiteGraphQL';

export const WWS_QUERY_KEY = ['wwsDetails'];

const useGetWws = ({isEnabled = true}) => {
  const weddingWebsite = useQuery({
    enabled: isEnabled,
    refetchOnWindowFocus: false,
    queryKey: WWS_QUERY_KEY,
    queryFn: async () => {
      const response = await WeddingWebsiteGraphQL.getWeddingWebsite();

      if (response?.error) {
        throw response.error;
      }

      return response;
    },
    staleTime: Infinity,
  });

  return {
    data: weddingWebsite.data,
    error: weddingWebsite.error,
    isError: weddingWebsite.isError,
    isLoading: weddingWebsite.isLoading,
  };
};

export default useGetWws;
